<template>
  <div v-if="!isAuthenticated && !isLoading" class="top-bar-wrap">
    <div class="topbar">
      <!-- <div class="mainlogo">
        <img class="app-logo" src="../assets/img/protractorNew2.svg" alt="Protractor">
      </div> -->
      <Menubar>
        <!-- <template #start>
          <img alt="logo" class="logo" src="../assets/img/protractorCompass_revNew2.svg" height="50">
        </template> -->
        <template #end>
          <span class="p-menubar-list">
            <Button class="p-menubar-item" label="Login" @click="login" />
          </span>
        </template>
      </Menubar>
    </div>
  </div>

  <div v-else-if="isAuthenticated" class="top-bar-wrap">
    <div :class="['topbar', 'auth', role]">
      <div class="mainlogo">
        <h2>Manager Client</h2>
      </div>
      <Menubar>
          <template #start>
              <!-- <img alt="logo" class="logo" src="../assets/img/protractorCompass_revNew2.svg" height="50"> -->
              <div v-if="role === 'SupportAdmin'" class="p-menubar-list">
                  <Dropdown :autoOptionFocus="false" :options="supportAdminMenuStore" optionLabel="label" placeholder="Stores" class="mainNav" @change="(event) => navigateTo(event.value.path)"/>
                  <Dropdown :autoOptionFocus="false" :options="supportAdminMenuEnterprise" optionLabel="label" placeholder="Enterprises" class="mainNav" @change="(event) => navigateTo(event.value.path)"/>
              </div>
              <div v-else class="p-menubar-list">
                  <Button class="p-menubar-item" v-for="item in getMenuItems()" @click="navigateTo(item.path)" :key="item.index">
                      {{ item.label }}
                  </Button>
              </div>
          </template>
          <template #end>
              <div class="p-menubar-list" style="display:flex;align-items:center;">
                <!-- <button class="p-button p-component p-menubar-item" type="button">Store Users<span class="p-ink" role="presentation" aria-hidden="true"></span></button> -->
                <Button v-if="role === 'SupportAdmin'" class="p-button p-component p-menubar-item sml" label="User Search" type="button" severity="secondary" @click="(event) => navigateTo('/users')" />
                <img :src="user?.picture" @click="() => { visible = true;}" alt="User's profile picture" class="border-circle img-fluid profile-picture" />
              </div>
              <Dialog class="profile" v-model:visible="visible" modal header="Profile">
                  <div class="image">
                      <img :src="user?.picture" alt="User's profile picture" class="border-circle img-fluid profile-picture" />
                  </div>
                  <div class="info">
                      <h2>{{ user?.name }}</h2>
                      <p class="lead text-muted"><strong>Email:</strong> {{ user?.email }}</p>
                      <p class="lead text-muted"><strong>Store name:</strong> {{ storename }}</p>
                      <p class="lead text-muted"><strong>User role:</strong> {{ role }}</p>
                      <Button label="log out" class="logout" @click="logout();" />
                  </div>
              </Dialog>
          </template>
      </Menubar>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useAuth0 } from '@auth0/auth0-vue';
import { onMounted, ref, watch } from 'vue';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import { useRouter } from 'vue-router';
import { useStore } from "../store";
import { computed } from 'vue';
import ApiService from "@/service/api.service";

const store = useStore();
const auth0 = useAuth0();
const router = useRouter();
const visible = ref(false);
const role = computed(() => store.state.role);
const storename = computed(() => store.state.storename);
const { user, isLoading, isAuthenticated, getAccessTokenSilently } = useAuth0();

onMounted(async () => {
  if (isAuthenticated.value === true) {
    const accessToken = await getAccessTokenSilently();
    await getUserInfo(accessToken);
    await getStoreDetails(accessToken);
    checkStoreStatus();
  }
})

// watch isLoading and isAuthenticated object to handle auth0 successful login - for initial login
const stop = watch([isLoading, isAuthenticated], async ([loading, auth]) => {
  if (!loading && auth) {
    const accessToken = await getAccessTokenSilently();
    await getUserInfo(accessToken);
    await getStoreDetails(accessToken);
    checkStoreStatus();
    stop();
  }
});

const checkStoreStatus = () => {
  const role = store.state.role;
  const storestatus = store.state.storestatus;
  if (role === 'StoreAdmin' && storestatus === 'Disable') {
    return router.push('/storedisable');
  }
}

const getUserInfo = async (accessToken: string) => {
  await ApiService.getUserInfo(accessToken);
}

const getStoreDetails = async (accessToken: string) => {
  const role = store.state.role;
  const allowedRoles = ['SupportAdmin', 'StoreAdmin'];
  if (allowedRoles.includes(role) === false) {
    return router.push('/storedisable');
  }
  await ApiService.getStoreDetails(accessToken, store.state.storeid);
}

const supportAdminMenuEnterprise = ref([
    {
        label: 'EnterpriseAdmin Users',
        path: '/enterpriseusers'
    }
]);

const supportAdminMenuStore = ref([
    {
        label: 'Stores',
        path: '/stores'
    },
    {
        label: 'StoreAdmin Users',
        path: '/adminusers'
    }
]);

const storeAdminMenu = ref([
  {
    label: 'Store Users',
    path: '/storeusers'
  }
])

/**
 * Menu list by role, new roles can be added here
 */
const menus = {
  StoreAdmin: storeAdminMenu.value
};

const logout = () => {
  sessionStorage.removeItem('vuex');
  localStorage.clear();
  auth0.logout({
    returnTo: window.location.origin
  });
};

const login = () => {
  auth0.loginWithRedirect()
}

/**
 * Menu items dynamically by role
 */
const getMenuItems = () => {
  return menus[role.value];
}

/**
 * Navigate to different pages
 * @param path 
 */
 const navigateTo = (path: string) => {
    router.push(path);
}
</script>
